import { frameColumns } from '../../../../../Member/utils/common';
import React, { useEffect, useMemo, useState } from 'react';
import MasterPermissions from '../../../../api/MasterPermissions';
import moment from 'moment';
import useDate from '../../../../utils/useDate';
import { Col } from 'react-bootstrap';
import AccountTable from './AccountTable';
import AccountDetailsFilter from './AccountDetailsFilter';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const AccountDetailsGrid = ({
  dataFetching,
  isAPIFailed,
  Transactions,
  TotalDeposit,
  TotalWithdrawl,
  ...otherProps
}) => {
  const { formatDate } = useDate();
  const frameDataToDisplay = (transactionList) => {
    if (transactionList?.length > 0) {
      const recordsToDisplay = [];
      const iterationCount = transactionList.length;
      for (let iIndex = 0; iIndex < iterationCount; iIndex++) {
        recordsToDisplay.push({
          ProcessedDate: formatDate(transactionList[iIndex].ProcessedDate),
          Description: transactionList[iIndex].Description,
          ClaimNumber: transactionList[iIndex].ClaimNumber,
          //Deposit: formatter.format( transactionList[ iIndex ].Deposit ),
          //Withdrawl: formatter.format( transactionList[ iIndex ].Withdrawl ),
          //Balance: formatter.format( transactionList[ iIndex ].Balance ),
          Deposit: transactionList[iIndex].Deposit,
          Withdrawl: transactionList[iIndex].Withdrawl,
          Balance: transactionList[iIndex].Balance,
          Status: transactionList[iIndex].Status,
          ClaimNo:
            transactionList[iIndex].ClaimNumber == null
              ? '000-0000000000-00'
              : transactionList[iIndex].ClaimNumber,
          TrxIndex: iIndex,
          ClaimOid: transactionList[iIndex].ClaimOid,
        });
      }
      console.log(recordsToDisplay);
      setRecordsToDisplay(recordsToDisplay);
    } else {
      console.log('No Transactions Found');
      setRecordsToDisplay([]);
    }
  };

  const filterByClaimNumber = (
    claimNumber,
    activeTransactionType,
    TransactionRecords = Transactions,
  ) => {
    if (claimNumber) {
      setIsSearching(true);
      const filteredRecords = TransactionRecords?.filter((ele, index) => {
        if (ele.ClaimNumber != '' && ele.ClaimNumber != null) {
          return ele.ClaimNumber.toLowerCase().includes(
            claimNumber.toString().toLowerCase(),
          );
        }
        return;
      });
      if (filteredRecords?.length < 1 && TransactionRecords.length > 0) {
        TransactionRecords.filter((ele, index) => {
          const dateInfo = claimNumber.split('-');
          console.log(moment(claimNumber).format('YYYY-MM-DD'));
          if (
            ele.ProcessedDate.includes(
              dateInfo?.length > 2
                ? moment(claimNumber).format('YYYY-MM-DD')
                : claimNumber,
            )
          ) {
            filteredRecords.push(ele);
          }
        });
      }
      if (activeTransactionType?.length > 0) {
        filterByTransactionType(activeTransactionType, '', filteredRecords);
      } else {
        frameDataToDisplay(filteredRecords);
      }
    } else {
      if (activeTransactionType?.length > 0) {
        filterByTransactionType(activeTransactionType, '', TransactionRecords);
      } else {
        setIsSearching(false);
        frameDataToDisplay(Transactions);
      }
    }
  };

  const filterByTransactionType = (
    uniqueDescriptions,
    claimNumber,
    TransactionRecords = Transactions,
  ) => {
    const filteredRecords = [];
    if (uniqueDescriptions?.length > 0) {
      setIsSearching(true);
      if (uniqueDescriptions?.length === 1) {
        if (uniqueDescriptions[0].label === 'Payment Amount') {
          TransactionRecords.filter((eachRecord) => {
            if (eachRecord.Withdrawl != null && eachRecord.Deposit === null) {
              filteredRecords.push(eachRecord);
            }
          });
        } else {
          TransactionRecords.filter((eachRecord) => {
            if (eachRecord.Deposit != null && eachRecord.Withdrawl === null) {
              filteredRecords.push(eachRecord);
            }
          });
        }
        if (claimNumber != '') {
          filterByClaimNumber(claimNumber, [], filteredRecords);
        } else {
          frameDataToDisplay(filteredRecords);
        }
      } else {
        if (claimNumber != '') {
          filterByClaimNumber(claimNumber, [], TransactionRecords);
        } else {
          frameDataToDisplay(TransactionRecords);
        }
      }
    } else {
      if (claimNumber != '') {
        filterByClaimNumber(claimNumber, [], TransactionRecords);
      } else {
        setIsSearching(false);
        frameDataToDisplay(TransactionRecords);
      }
    }
  };

  const resetFilter = () => {
    frameDataToDisplay(Transactions);
    setIsSearching(false);
  };

  const columnNames = useMemo(() => {
    return frameColumns(TotalDeposit, TotalWithdrawl);
  }, [Transactions]);

  const [recordsToDisplay, setRecordsToDisplay] = useState([]);
  //const [ uniqueDescriptions, setUniqueDescriptions ] = useState( [] );
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    //frameDistinctDescriptions( Transactions );
    frameDataToDisplay(Transactions);
  }, [Transactions]);

  return (
    <>
      {MasterPermissions.CheckPermission('View Transaction Details') && (
        <>
          <AccountDetailsFilter
            filterByClaimNumber={filterByClaimNumber}
            filterByTransactionType={filterByTransactionType}
            resetFilter={resetFilter}
            data={recordsToDisplay}
            keyField={columnNames}
          />
          <Col sm={12}>
            <div className="account-details-grid" id="pdfdiv">
              <AccountTable
                className="account-table"
                columns={columnNames}
                data={recordsToDisplay}
                keyField={columnNames}
                isSearching={isSearching}
                preserveData={otherProps.preserveData}
              />
            </div>
          </Col>
        </>
      )}
    </>
  );
};

export default AccountDetailsGrid;
